<div class="text-center my-3">
    <img src="assets/icons/something-went-wrong-icon.svg" width="60">

    <h1>{{ 'si_pts_chrome_page_not_found_header' | cmsText | async }}</h1>

    <p [appParagraph]="2">{{ 'si_pts_chrome_page_not_found_text' | cmsText | async }}</p>

    <a [routerLink]="'/dashboard'" appStandardButton>{{ 'si_pts_chrome_error_back' | cmsText | async }}</a>

</div>
